export const cartHook = {
    getItems,
    clean
}

function getItems(rechargeProducts) {
    let products = [];
    if (!rechargeProducts) {
        let cartItems = JSON.parse(localStorage["pruchaseList"]);
        cartItems.map(provider => {
            provider.Items.map(itemtemp => {
                let item = {
                    ProductId: itemtemp.ProductId,
                    UrlImage: itemtemp.UrlImage,
                    Name: itemtemp.Name,
                    ProductPrice: itemtemp.Price,
                    Cant: itemtemp.Quantity,
                    ProductCode: itemtemp.Code,
                    Description: itemtemp.Descripcion,
                    ProviderId: itemtemp.ProviderId,
                    CountryCode: itemtemp.CountryCode,
                    CampaingCode: itemtemp.CampaingCode,
                    FcPromocionID: itemtemp.FcPromocionID
                };
                products.push(item);
            })
        });
    }
    else {
        products.push(rechargeProducts)
    }

    return products;
}

async function clean() {
    localStorage["pruchaseTotal"] = "0";
    localStorage["pruchaseList"] = "[]";
}